import { render } from "./ProductDetails.vue?vue&type=template&id=50ae4db4&scoped=true"
import script from "./ProductDetails.vue?vue&type=script&lang=js"
export * from "./ProductDetails.vue?vue&type=script&lang=js"

import "./ProductDetails.vue?vue&type=style&index=0&id=50ae4db4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-50ae4db4"

export default script